// @flow

import { getEntryFromLocalStorage } from '../../helpers';
import type { FAQFeedback } from './types';

const STORAGE_KEY = 'faq-feedback/v1';

export const getFAQFeedbackFromStorage = (): FAQFeedback => {
  let faqFeedback: ?FAQFeedback = {};

  try {
    faqFeedback = getEntryFromLocalStorage(STORAGE_KEY);
  } catch (error) {
    console.error(error);
    throw error;
  }

  if (faqFeedback && typeof faqFeedback === 'object') {
    return faqFeedback;
  }

  return {};
};

export const addFAQFeedbackToStorage = (faqFeedback: FAQFeedback) => {
  const storage = getFAQFeedbackFromStorage();
  localStorage.setItem(STORAGE_KEY, JSON.stringify({
    ...storage,
    ...faqFeedback,
  }));
};

export const storeFAQFeedbackInStorage = (faqFeedbacks: FAQFeedback) => (
  localStorage.setItem(STORAGE_KEY, JSON.stringify(faqFeedbacks))
);
